import { isToBApp, isNuoYa } from 'base/config'

const ua = navigator.userAgent.toLowerCase()
let androidVersion = ua.match(/android (.*?);/)
if (androidVersion && androidVersion[1]) {
  androidVersion = androidVersion[1].split('.')[0]
}

let iosVersion = ua.match(/cpu iphone os (.*?) like mac os/)
if (iosVersion && iosVersion[1] && iosVersion[1].split('_')) {
  iosVersion = iosVersion[1].split('_')[0]
}

const isMatchAndroid = appBridge.isAndroid() && androidVersion >= 6
const isMatchIos = appBridge.isIos() && iosVersion >= 11
const showScreenRecorder = appBridge && appBridge.checkAppFeature('SHOW_SCREEN_RECORDER')
export default {
  data() {
    return {
      isSupportRecordScreen: isNuoYa || (showScreenRecorder && (isMatchAndroid || isMatchIos))
    }
  },
  computed: {
    isSchemeShowByApp() {
      return (isToBApp && this.isSupportRecordScreen) || !isToBApp
    },
  }
}
